import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, catchError, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(private _router: Router, private route: ActivatedRoute) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(() => {
        localStorage.removeItem('authErrorCounter');
      }),
      catchError((err) => this.handleAuthError(req, err))
    );
  }

  private handleAuthError(
    req: HttpRequest<any>,
    err: HttpErrorResponse
  ): Observable<any> {
    if (err.status !== 401) {
      throw err;
    }
    
    if (req.url.startsWith('https://graph-api')) {
      // This forces the MsalInterceptor to get a new toke
      // for the graphQL calls
      return throwError(() => err);
    }

    let authErrorCounter = +localStorage.getItem('authErrorCounter');

    if (authErrorCounter > 3) {
      localStorage.removeItem('authErrorCounter');
      this._router.navigateByUrl('error', {
        state: {
          errorTitle: 'Failed to authenticate.',
          errorMessage: 'Please reach out to servicedesk@claytonhomes.com.',
        },
      });
    } else {
      authErrorCounter++;
      localStorage.clear();
      localStorage.setItem('authErrorCounter', authErrorCounter.toString());
      location.reload();
    }
    throw err;
  }
}
